export default "__VITE_ASSET__BgQVytrA__"